import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: '4rem',
    borderBottom: '1px solid rgba(230, 234, 236, 0.9)',
    boxSizing: 'border-box',
    padding: '0.75rem 1.5rem',

    [theme.breakpoints.down('md')]: {
      padding: '0.75rem 5%'
    }
  },

  avatar: {
    width: '1.5rem',
    height: '1.5rem',
    fontSize: theme.size.base
  },

  tabs: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1rem',
    height: '100%',

    [theme.breakpoints.down('md')]: {
      marginLeft: '0'
    }
  },

  tab: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '38px',
    height: '100%',
    cursor: 'pointer',

    '& > *': {
      cursor: 'pointer'
    },

    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },

  avatarTab: {
    '& > label': {
      display: 'flex',
      alignItems: 'center',

      '& > :first-child': {
        width: 'min-content'
      }
    }
  },

  tabBottom: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '2px',
    backgroundColor: 'grey'
  },

  tabBottomActive: {
    background: `linear-gradient(91deg, ${theme.gradient.button.start} 0%, ${theme.gradient.button.stop} 100%)`
  },

  tabName: {
    padding: '0 10px',
    fontSize: theme.size.sm,
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },

  selectedTab: {
    color: '#323436'
  },

  name: {
    '& > div': {
      opacity: '0.35',
      marginLeft: '0.375rem'
    },

    [theme.breakpoints.down(768)]: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '0.5rem',
      fontSize: theme.size.sm,
      maxWidth: '7rem',
      whiteSpace: 'nowrap'
    },

    [theme.breakpoints.down('md')]: {
      marginLeft: '0.5rem',
      fontSize: theme.size.sm,
      maxWidth: '7rem',
      whiteSpace: 'nowrap'
    },

    [theme.breakpoints.up(768)]: {
      marginLeft: '0.5rem',
      fontSize: theme.size.sm,
      maxWidth: '10rem',
      whiteSpace: 'nowrap'
    }
  },

  save: {
    fontSize: theme.size.sm
  },

  menu: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '0.5rem',
    height: 'calc(100% + 4px)'
  },

  menuIcon: {
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    transform: 'rotate(90deg)',
    height: '1rem',
    width: '1rem'
  },

  pinButton: {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  }
}))

export default useStyles
